<template>
  <div class="clientprofile">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Info</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    <router-link to="/license/list">License</router-link>
                  </li>
                  <li class="breadcrumb-item active">Info</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view" v-if="!!loading">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a href>
                          <Skeleton :count="1" :circle="true" :height="'100px'" :width="'100px'" />
                        </a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0">
                              <Skeleton :count="1" />
                            </h3>
                            <small class="text-muted">
                              <Skeleton :count="1" />
                            </small>
                            <div class="staff-msg">
                              <Skeleton :count="1" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <span class="title">Phone:</span>
                              <span class="text">
                                <Skeleton :count="1" />
                              </span>
                            </li>
                            <li>
                              <span class="title">Email:</span>
                              <span class="text">
                                <Skeleton :count="1" />
                              </span>
                            </li>
                            <li>
                              <span class="title">Last Sent:</span>
                              <span class="text">
                                <Skeleton :count="1" />
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a href>
                          <img src="@/assets/profiles/avatar-19.jpg" alt />
                        </a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0">{{licenseInfo.license_name}}</h3>
                            <small class="text-muted">{{licenseInfo.status_label}}</small>
                            <div class="staff-id"></div>
                            <div class="staff-msg">
                              <router-link
                                :to="'/omni/connect-to-agent-owner?license_id='+licenseInfo.id"
                                class="btn btn-custom"
                              >
                                <i class="fa fa-whatsapp"></i> Chat
                              </router-link>
                              <router-link
                                :title="'Buy an activation package'"
                                class="btn btn-custom"
                                :to="'/subscriptions?license_id='+licenseInfo.id"
                              >
                                <i class="fa fa-shopping-cart"></i>
                              </router-link>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <span class="title">Phone:</span>
                              <span class="text">{{licenseInfo.license_phone_number}}</span>
                            </li>
                            <li>
                              <span class="title">Email:</span>
                              <span class="text">{{licenseInfo.license_email}}</span>
                            </li>
                            <!-- <li>
                              <span class="title">Sent:</span>
                              <span class="text">2 minutes ago.</span>
                            </li>-->
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card tab-box">
            <div class="row user-tabs">
              <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul class="nav nav-tabs nav-tabs-bottom">
                  <li class="nav-item col-sm-3">
                    <a class="nav-link active" data-toggle="tab" href="#myprojects">Overview</a>
                  </li>
                  <li class="nav-item col-sm-3">
                    <a class="nav-link" data-toggle="tab" href="#tasks">API</a>
                  </li>
                  <li class="nav-item col-sm-3">
                    <a class="nav-link" data-toggle="tab" href="#utility">Utility</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="tab-content profile-tab-content">
                <!-- Projects Tab -->
                <div id="myprojects" class="tab-pane fade show active">
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-md-4 col-xl-3">
                      <div class="card dash-widget">
                        <div class="card-body">
                          <span class="dash-widget-icon">
                            <i class="fa fa-user"></i>
                          </span>
                          <div class="dash-widget-info">
                            <h3>{{numAgentTotal}}</h3>
                            <span>Agents</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-sm-6 col-md-4 col-xl-3">
                      <div class="card dash-widget">
                        <div class="card-body">
                          <span class="dash-widget-icon">
                            <i class="fa fa-envelope"></i>
                          </span>
                          <div class="dash-widget-info">
                            <h3>{{nFormatter(numMessageTotal)}}</h3>
                            <span>Messages</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-md-4 col-xl-3">
                      <whatsapp :licenseInfo="licenseInfo" />
                    </div>
                  </div>
                </div>
                <!-- /Projects Tab -->
                <!-- {{licenseInfo}} -->
                <!-- Task Tab -->
                <div id="tasks" class="tab-pane fade">
                  <div class="project-task">
                    <div class="row">
                      <div class="col-sm-12 col-md-8">
                        <div class="form-group row">
                          <div class="col-lg-10">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">Key :</span>
                              </div>
                              <input
                                :value="licenseInfo.license_key"
                                type="text"
                                class="form-control js-copytextarea"
                                placeholder
                                aria-label
                                aria-describedby="basic-addon2"
                                readonly
                              />
                              <div class="input-group-append">
                                <button
                                  type="button"
                                  class="btn btn-white dropdown-toggle"
                                  data-toggle="dropdown"
                                >Actions</button>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <a
                                    class="dropdown-item js-textareacopybtn"
                                    href="javascript:void(0)"
                                  >
                                    <i class="fa fa-file"></i> Copy
                                  </a>
                                  <a class="dropdown-item" @click.prevent="generateLicenseKey">
                                    <i class="fa fa-key"></i> Generate a new key
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <p class="text-muted">
                          <b>About the API</b>
                          <br />We makes it easy for programmers to integrate many features into other applications. Interested in learning more?
                        </p>
                        <a
                          target="_blank"
                          :href="docAPI"
                          class="btn btn-primary"
                        >Read our API documentation</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="utility" class="tab-pane fade">
                  <div class="project-task">
                    <div class="row">
                      <div class="col-sm-12 col-md-12">
                        <p>
                          <span class="badge badge-warning">
                            <b>!! WARNING !!</b>
                          </span>
                          <br />
                          <span
                            class="text-muted"
                          >We ensure that we don't use your data, please delete it whenever you want.</span>
                        </p>
                        <div class="alert alert-warning">
                          By deleting data, you understand that the following features will be affected:
                          <br />- Chat history.
                          <br />- Auto responder frequency.
                          <br />- Broadcast history.
                          <br />- And others related to the messages.
                        </div>
                        <button
                          :disabled="loadingEmpty"
                          @click.prevent="emptyInbox"
                          class="btn btn-sm btn-danger"
                        >
                          <i class="fa fa-trash"></i> Empty Inbox
                        </button>
                        <button
                          :disabled="loadingEmpty"
                          @click.prevent="emptyOutbox"
                          class="btn btn-sm btn-danger"
                        >
                          <i class="fa fa-trash"></i> Empty Outbox
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Task Tab -->
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleAlert from "vue-simple-alert";

import { Skeleton } from "vue-loading-skeleton";
import { nFormatter } from "@/utils/helper";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Whatsapp from "./whatsapp.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Whatsapp
  },
  async created() {
    // console.log("route", this.$route.query.id);
    var id = await this.$route.query.id;
    await this.getLicenseById(id);

    this.getAgentTotal(id);
    this.getMessageTotal(id);
  },
  data() {
    return {
      loadingEmpty: false,
      loading: false,
      docAPI: process.env.VUE_APP_API_DOC,
      licenseInfo: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_email: "",
        license_masa_aktif: "",
        is_unlimited: "",
        status_label: ""
      }
    };
    //  isactive : true
  },
  computed: {
    numAgentTotal() {
      return this.$store.state.license.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.license.numMessageTotal;
    }
  },
  methods: {
    emptyOutbox() {
      this.loadingEmpty = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase the items in the Outbox?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let formParam = {
              license_id: this.licenseInfo.id
            };
            this.$store
              .dispatch("license/emptyOutbox", formParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                });
              });
            this.loadingEmpty = false;
          } else {
            this.loadingEmpty = false;
          }
        })
        .catch(e => {
          this.loadingEmpty = false;
        });
    },
    emptyInbox() {
      this.loadingEmpty = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase the items in the Inbox?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let formParam = {
              license_id: this.licenseInfo.id
            };
            this.$store
              .dispatch("license/emptyInbox", formParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                });
              });
            this.loadingEmpty = false;
          } else {
            this.loadingEmpty = false;
          }
        })
        .catch(e => {
          this.loadingEmpty = false;
        });
    },
    generateLicenseKey() {
      this.$fire({
        title:
          "Are you sure you will continue this action? This action will break the on going API connection.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          let params = {};
          params = {
            id: this.licenseInfo.id
          };
          // console.log("params", params);
          this.$store
            .dispatch("license/generateLicenseKey", params)
            .then(response => {
              this.getLicenseById(this.licenseInfo.id);
              this.$fire({
                title: "Success",
                text: response.msg,
                type: "success",
                timer: 3000
              });
            });
        }
      });
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal(id) {
      let params = {};
      params = {
        license_id: id,
        provider: "whatsapp"
      };
      this.$store.dispatch("license/getMessageTotal", params);
    },
    getAgentTotal(id) {
      let params = {};

      params = {
        license_id: id
      };
      this.$store.dispatch("license/getAgentTotal", params);
    },
    async getLicenseById(id) {
      this.loading = await true;

      await this.$store
        .dispatch("license/getLicenseById", id)
        .then(response => {
          var { data } = response;
          this.licenseInfo = data;

          if (data.is_unlimited == 1) {
            this.licenseInfo.status_label = "Active";
          } else {
            this.licenseInfo.license_masa_aktif = data.license_masa_aktif;
          }
          //   console.log("response", response);
        })
        .catch(error => {
          // this.$route.push({to:"/license/list"})
          this.$router.replace({ path: "/license/list" });
        });
      this.loading = await false;
    }
  },
  mounted() {
    var copyTextareaBtn = document.querySelector(".js-textareacopybtn");

    copyTextareaBtn.addEventListener("click", function(event) {
      var copyTextarea = document.querySelector(".js-copytextarea");
      copyTextarea.focus();
      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        if (successful) {
          VueSimpleAlert.fire({
            title: "Success",
            text: "Copied successfully!",
            type: "success",
            timer: 3000
          });
        }
        // console.log("Copying text command was " + msg);
      } catch (err) {
        // console.log("Oops, unable to copy");
        VueSimpleAlert.fire({
          title: "Success",
          text: "Copied successfully!",
          type: "success",
          timer: 3000
        });
      }
    });

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "clientprofile"
};
</script>


// WEBPACK FOOTER //
// src/views/license/info.vue